export function stringIncludes(haystack: string, needle: string, caseSensitive = false): boolean {
  haystack = (haystack || '').toString();
  needle = (needle || '').toString();

  if (!caseSensitive) {
    haystack = haystack.toLowerCase();
    needle = needle.toLowerCase();
  }

  return haystack.includes(needle);
}

export function containsHtml(str: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}

// Used to convert a string into an arbitrary but idempotent hash
// Useful for deterministically generating content like colors from strings
// Stolen from https://stackoverflow.com/a/16533568
export function stringToHash(str: string): number {
  // seed
  let hash = 5381;

  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) + hash + str.charCodeAt(i); /* hash * 33 + c */
  }

  return hash;
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Unicode_Property_Escapes
// https://github.com/tc39/proposal-regexp-unicode-property-escapes#matching-emoji
export const EMOJI_REGEX = /\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;
